import React, { useEffect, useState, useRef } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useDispatch, useSelector } from 'react-redux';
import { getReportBusinessGrapth } from '../../../redux/profile/action';
import ExportButtons from '../ExportButtons';
import { prepareChartData } from '../../../utils/graphUtils';

const MultyChartLineGraph = ({ start_date, end_date, type }) => {
    const dispatch = useDispatch();
    const graphdetails = useSelector(({ profile: { dashboardreportbusinessgraph } }) => dashboardreportbusinessgraph);

    const chartRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [chartData, setChartData] = useState({
        series: [
            { name: "BSA", data: [] },
            { name: "TAI", data: [] },
            { name: "BSM", data: [] },
            { name: "OTS", data: [] },
            { name: "PBP", data: [] },
            { name: "WBO", data: [] },
            { name: "PTJ", data: [] },
        ],
        options: {
            chart: {
                type: "line",
                height: 350,
                zoom: { enabled: false },
            },

            /* 👇 ADD THIS */
            colors: [
                "#008FFB", // BSA
                "#00E396", // TAI
                "#FEB019", // BSM
                "#FF4560", // OTS
                "#775DD0", // PBP
                "#3F51B5", // WBO
                "#546E7A", // PTJ
            ],

            dataLabels: { enabled: false },
            stroke: { curve: "smooth", width: 3 },
            subtitle: { text: "Counts Over Time", align: "left" },
            xaxis: { categories: [], type: "category" },
            yaxis: { opposite: true },
            legend: { horizontalAlign: "left" },
        },
    });


    // Fetch graph data
    useEffect(() => {
        if (start_date && end_date && type) {
            dispatch(getReportBusinessGrapth(start_date, end_date, type));
        }
    }, [start_date, end_date, type, dispatch]);

    useEffect(() => {
        if (graphdetails?.history) {
            setLoading(false);

            const seriesData = Array.isArray(graphdetails.history) ? graphdetails.history : [];

            // Use prepareChartData for each series individually
            const auctionData = prepareChartData(
                seriesData.map(item => ({ due_date: item.date, count: parseInt(item.auction_count, 10) || 0 })),
                'count'
            );
            const rentalData = prepareChartData(
                seriesData.map(item => ({ due_date: item.date, count: parseInt(item.rental_count, 10) || 0 })),
                'count'
            );
            const saleData = prepareChartData(
                seriesData.map(item => ({ due_date: item.date, count: parseInt(item.sale_count, 10) || 0 })),
                'count'
            );
            const bxpData = prepareChartData(
                seriesData.map(item => ({ due_date: item.date, count: parseInt(item.bxp_count, 10) || 0 })),
                'count'
            );
            const projectData = prepareChartData(
                seriesData.map(item => ({ due_date: item.date, count: parseInt(item.project_count, 10) || 0 })),
                'count'
            );
            const constestData = prepareChartData(
                seriesData.map(item => ({ due_date: item.date, count: parseInt(item.contest_count, 10) || 0 })),
                'count'
            );
            const jobData = prepareChartData(
                seriesData.map(item => ({ due_date: item.date, count: parseInt(item.job_count, 10) || 0 })),
                'count'
            );

            // Use the X-axis from one of the series (they all should have same dates after prepareChartData)
            const categories = auctionData.map(item => item.name);

            setChartData(prev => ({
                series: [
                    { name: "BSA", data: auctionData.map(item => item.count) },
                    { name: "TAI", data: rentalData.map(item => item.count) },
                    { name: "BSM", data: saleData.map(item => item.count) },
                    { name: "OTS", data: bxpData.map(item => item.count) },
                    { name: "PBP", data: projectData.map(item => item.count) },
                    { name: "WBO", data: constestData.map(item => item.count) },
                    { name: "PTJ", data: jobData.map(item => item.count) },
                ],
                options: {
                    ...prev.options,
                    xaxis: { ...prev.options.xaxis, categories }
                }
            }));
        }
    }, [graphdetails]);

    return (
        <>
            <ExportButtons targetRef={chartRef} filename="multy_chart_history" data={graphdetails?.history} />
            <div ref={chartRef}>
                <div id="chart">
                    {loading ? (
                        <div>Loading chart...</div>
                    ) : (
                        <ReactApexChart
                            options={chartData.options}
                            series={chartData.series}
                            type="line"
                            height={350}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default MultyChartLineGraph;
